/* GutKnie – minimales Theme-Skript */
(function () {
  'use strict';

  /* Mobile-Navigation */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-burger]');
    if (!burger) return;
    var nav = document.querySelector('[data-nav]');
    if (!nav) return;
    var open = nav.classList.toggle('open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* Bundle-Auswahl auf der Produktseite: Variante setzen + Preis aktualisieren */
  var form = document.querySelector('.pdp__form') || document.querySelector('[data-variant-form]');
  if (form) {
    var data = document.querySelector('[data-variant-json]');
    var variants = data ? JSON.parse(data.textContent) : [];

    function currentSelection() {
      var picked = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) picked[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return picked;
    }

    function update() {
      var picked = currentSelection();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return picked[i] === undefined || o === picked[i]; });
      });
      var idInput = form.querySelector('[name="id"]');
      var btn = form.querySelector('[data-add]');
      var priceEl = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare]');

      if (!match) {
        if (btn) { btn.disabled = true; btn.textContent = 'Nicht verfügbar'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (compareEl) {
        compareEl.textContent = match.compare || '';
        compareEl.style.display = match.compare ? '' : 'none';
      }
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? (btn.getAttribute('data-label') || 'In den Warenkorb') : 'Ausverkauft';
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', update);
    update();
  }
})();

/* Countdown im Sale-Banner */
(function () {
  var el = document.getElementById('sale-banner');
  if (!el) return;
  var box = el.querySelector('[data-countdown]');
  if (!box) return;
  var h = box.querySelector('[data-h]'), m = box.querySelector('[data-m]'), s = box.querySelector('[data-s]');

  function target() {
    if (el.dataset.mode === 'date' && el.dataset.until) {
      var t = new Date(el.dataset.until.replace(' ', 'T'));
      if (!isNaN(t)) return t;
    }
    var d = new Date();               // Mitternacht des laufenden Tages
    d.setHours(24, 0, 0, 0);
    return d;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var diff = target() - new Date();
    if (diff <= 0) {
      if (el.dataset.mode === 'date') { box.style.display = 'none'; return; }
      diff = 0;
    }
    var sec = Math.floor(diff / 1000);
    h.textContent = pad(Math.floor(sec / 3600));
    m.textContent = pad(Math.floor(sec % 3600 / 60));
    s.textContent = pad(sec % 60);
  }
  tick();
  setInterval(tick, 1000);
})();

/* Kommentar-Karussell: Wischen, Pfeile, Punkte */
(function () {
  document.querySelectorAll('[data-fbc]').forEach(function (root) {
    var track = root.querySelector('[data-fbc-track]');
    if (!track) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fbc-dot]'));
    var prev = root.querySelector('[data-fbc-prev]');
    var next = root.querySelector('[data-fbc-next]');

    function count() { return track.children.length; }
    function step() { return track.clientWidth; }
    function index() { return Math.round(track.scrollLeft / Math.max(step(), 1)); }

    function mark() {
      var i = Math.min(Math.max(index(), 0), count() - 1);
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
    }

    function go(i) {
      var n = (i + count()) % count();
      track.scrollTo({ left: n * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-fbc-dot'), 10)); });
    });

    var t = null;
    track.addEventListener('scroll', function () {
      if (t) clearTimeout(t);
      t = setTimeout(mark, 70);
    }, { passive: true });

    var letzteBreite = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === letzteBreite) return;
      letzteBreite = window.innerWidth;
      mark();
    });
    mark();
  });
})();


/* Paketwahl: Menge und Preis im Kaufbereich mitfuehren */
(function () {
  var form = document.querySelector('.pdp__form');
  if (!form) return;
  var mengenfeld = form.querySelector('[data-quantity]');
  var variantfeld = form.querySelector('[data-variant-feld]');
  var basisVariante = variantfeld ? variantfeld.getAttribute('data-basis-variante') : null;
  var preis = form.querySelector('[data-price]');
  var streich = form.querySelector('[data-compare]');

  function uebernehmen(input) {
    if (!input) return;
    var eigeneVariante = input.getAttribute('data-variant-id');
    if (variantfeld) variantfeld.value = eigeneVariante || basisVariante;
    if (mengenfeld) mengenfeld.value = input.getAttribute('data-qty') || '1';
    if (preis && input.getAttribute('data-preis')) preis.textContent = input.getAttribute('data-preis');
    if (streich) {
      var voll = input.getAttribute('data-voll');
      var jetzt = input.getAttribute('data-preis');
      if (voll && jetzt && voll !== jetzt) {
        streich.textContent = voll;
        streich.style.display = '';
      } else {
        streich.textContent = '';
        streich.style.display = 'none';
      }
    }
  }

  form.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'paketwahl') uebernehmen(e.target);
  });

  uebernehmen(form.querySelector('input[name="paketwahl"]:checked') || form.querySelector('input[name="paketwahl"]'));
})();


/* Produktgalerie: Wischen, Pfeile, Vorschauleiste */
(function () {
  document.querySelectorAll('[data-gal]').forEach(function (root) {
    var track = root.querySelector('[data-gal-track]');
    if (!track) return;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gal-dot]'));
    var prev = root.querySelector('[data-gal-prev]');
    var next = root.querySelector('[data-gal-next]');
    var cur = root.querySelector('[data-gal-cur]');
    var anzahl = track.children.length;

    function index() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }

    function mark() {
      var i = Math.min(Math.max(index(), 0), anzahl - 1);
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (cur) cur.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === anzahl - 1;
      var aktiv = thumbs[i];
      var leiste = aktiv && aktiv.parentElement;
      if (aktiv && leiste) {
        /* nur waagerecht innerhalb der Leiste scrollen - niemals die Seite bewegen */
        var links = aktiv.offsetLeft;
        var rechts = links + aktiv.offsetWidth;
        var sicht = leiste.scrollLeft;
        var breite = leiste.clientWidth;
        if (links < sicht) {
          leiste.scrollLeft = Math.max(0, links - 12);
        } else if (rechts > sicht + breite) {
          leiste.scrollLeft = rechts - breite + 12;
        }
      }
    }

    function go(i) {
      var n = Math.min(Math.max(i, 0), anzahl - 1);
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-gal-dot'), 10)); });
    });

    var timer = null;
    track.addEventListener('scroll', function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(mark, 70);
    }, { passive: true });

    var letzteBreite = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === letzteBreite) return;
      letzteBreite = window.innerWidth;
      mark();
    });
    mark();
  });
})();


/* Versand-Zeitleiste: Termine ab heute, Countdown bis Bestellschluss */
(function () {
  var box = document.querySelector('[data-ship]');
  if (!box) return;

  var wochentage = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
  var monate = ['Jan.','Feb.','März','April','Mai','Juni','Juli','Aug.','Sept.','Okt.','Nov.','Dez.'];

  function plus(tage) {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + tage);
    return d;
  }
  function kurz(d) { return d.getDate() + '. ' + monate[d.getMonth()]; }
  function spanne(a, b) {
    if (a.getTime() === b.getTime()) return kurz(a);
    if (a.getMonth() === b.getMonth()) return a.getDate() + '. – ' + kurz(b);
    return kurz(a) + ' – ' + kurz(b);
  }

  var vMin = parseInt(box.dataset.versandMin, 10) || 1;
  var vMax = parseInt(box.dataset.versandMax, 10) || 2;
  var lMin = parseInt(box.dataset.lieferMin, 10) || 5;
  var lMax = parseInt(box.dataset.lieferMax, 10) || 7;

  var d1 = box.querySelector('[data-ship-d1]');
  var d2 = box.querySelector('[data-ship-d2]');
  var d3 = box.querySelector('[data-ship-d3]');
  if (d1) d1.textContent = 'heute, ' + kurz(plus(0));
  if (d2) d2.textContent = spanne(plus(vMin), plus(vMax));
  if (d3) d3.textContent = spanne(plus(lMin), plus(lMax));

  var cd = box.querySelector('[data-ship-countdown]');
  if (cd) {
    var tick = function () {
      var ziel = new Date();
      ziel.setHours(24, 0, 0, 0);
      var sek = Math.max(0, Math.floor((ziel - new Date()) / 1000));
      var std = Math.floor(sek / 3600);
      var min = Math.floor(sek % 3600 / 60);
      cd.textContent = std + ' Std. ' + min + ' Min.';
    };
    tick();
    setInterval(tick, 30000);
  }
})();
